import {isEmpty,isNull} from 'lodash';
import * as firebase from 'firebase/app';
import {firebaseConfig} from '../config/firebase';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import Authenticated from './authenticated';
import * as URL from '../utility/url';
import Administrator from '../resources/admin';
//import Homepage from '../resources/users';
import HomepageController from '../controller/homepage';

/**
 *--------------------------*
 | # |       Services       |
 *--------------------------*
 | 1 | Authenticated        |
 | 2 | Firebase setting     |
 | 3 | Detection Connected  |
 *--------------------------*
 * 
 * @author wadahkode <mvp.dedefilaras@gmail.com>
 * @since version v1.085
 */
export const bind = (config) => {
    const Auth = new Authenticated({
        "administrator": "superuser",
        "users": "normal"
    });
    
    // Authenticate for administrator
    Auth.isAdmin((status,data) => {
        if (config.env == 'development') {
            generalDomain(status, config.development.forAdmin.globalPattern, config.development.forAdmin.homepage);
        } else {
            generalDomain(status, config.production.forAdmin.globalPattern, config.production.forAdmin.homepage);
        }
        
        if (status) {
            let admin = new Administrator((config.env == 'development') ? config.development.forAdmin.globalPattern : config.production.forAdmin.globalPattern, data);
            return admin.getServices();
        }
    });
    
    // Authenticate for normal user
    Auth.isUsers((status, data) => {
        if (config.env == 'development') {
            generalDomain(status, config.development.forUser.globalPattern, config.development.forUser.homepage);
        } else {
            generalDomain(status, config.production.forUser.globalPattern, config.production.forUser.homepage);
        }
        
        if (status) {
            let homepage = new HomepageController((config.env == 'development') ? config.development.forUser.globalPattern : config.production.forUser.globalPattern, data);
            return homepage.index();
        }
    });
    
    var containerMessage = document.querySelector('.container-message');
    
    if (window.sessionStorage.getItem('user-not-auth') && window.location.pathname.match('login')) {
       var message = window.sessionStorage.getItem('user-not-auth');
       containerMessage.innerHTML = message;
       containerMessage.setAttribute("uk-alert","");
       containerMessage.classList.add('uk-alert');
       containerMessage.classList.add('uk-alert-warning');
    } else {
        window.sessionStorage.removeItem('user-not-auth');
    }
};

export const generalDomain = (status,pattern,url) => {
    const Auth = new Authenticated({
        "administrator": "superuser",
        "users": "normal"
    });
    
    URL.parse('', pattern)
        .then(response => {
            return ((response && !status) ? Auth.redirectTo('../login.html') : false);
        })
        .catch(response => {
            return ((response && status) ? setTimeout(() => Auth.redirectTo(url),3000) : false);
        });
};

//- this function as same with generalDomain function
export const githubPagesDomain = (status, pattern, url) => {
    const Auth = new Authenticated({
        "administrator": "superuser",
        "users": "normal"
    });
    
    URL.parse('', pattern)
        .then(response => {
            return ((response && !status) ? Auth.redirectTo('../login.html') : false);
        })
        .catch(response => {
            return ((response && status) ? setTimeout(() => Auth.redirectTo(url),3000) : false);
        });
};

export const setCloudService = (prepend, callback) => {
    if (!prepend) {
        return callback(false);
    }
    firebase.initializeApp(firebaseConfig);
    
    return callback(true);
};

export const isConnected = (callback) => {
    return firebase.database().ref('/.info/connected')
        .on('value', snap => {
            setTimeout(function() {
                if (snap.val() === true) {
                    callback(true);
                }
            }, 3000);
        });
};